/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/
import React, {useEffect, useState} from "react";
import PartnerService from "../../services/partner.service";
import PropTypes from "prop-types";
import ConfirmPasswordModal from "../Account/ConfirmUser/ConfirmPasswordModal";
import CommonTable from "../CommonTable/CommonTable";
import Snackbar from "@mui/material/Snackbar";
import Loader from "../Loader/Loader";

const ManagePartners = ({loggedInCustomerOrganization, onLogOff}) => {
    const [loading, setLoading] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState('');
    const [partners, setPartners] = useState([]);
    const [partnerId, setPartnerId] = useState(0);
    const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);

    const columns = [
        { field: 'organizationId', header: 'Organization ID' },
        { field: 'name', header: 'Name' },
        { field: 'company', header: 'Company' },
        {
            field: 'isActive',
            header: 'Actions',
            sortable: false,
            render: (row) => row.isActive ? (
                    <button className="btn-small secondary-btn btn-danger" onClick={() => onDeleteClick(row.organizationId)}> Delete </button>)
                : (<button className="btn-small secondary-btn btn-warning" onClick={() => onRestoreClick(row.organizationId)}> Restore </button>)
        }
    ];

    useEffect(() => {
        let isMounted = true;
        PartnerService.getmainpartners(loggedInCustomerOrganization).then((response)=>{
            if (isMounted) {
                setPartners(response);
            }
        })

        return () => {
            isMounted = false;
        };
    }, [loggedInCustomerOrganization]);

    function onDeleteClick(orgId){
        setPartnerId(orgId);
        setShowPasswordConfirmation(!showPasswordConfirmation);

    }
    function deletePartner(){
        setShowPasswordConfirmation(false);
        setLoading(true);
        PartnerService.softdelete(partnerId).then(r =>{
            setLoading(false);
            setMessage(`delete partner status is: ${r}`);
            setShowMessage(true);
        }).then(r=>{
            setTimeout(() => {
                setMessage('');
                setShowMessage(false);
                window.location.reload();
            }, 3000);
        });

    }
    function onRestoreClick(orgId){
        setLoading(true);
        PartnerService.resurrect(orgId).then(r => {
            setLoading(false);
            setMessage(`restore partner status is: ${r}`);
            setShowMessage(true);
        }).then(r=>{
            setTimeout(() => {
                setMessage('');
                setShowMessage(false);
                window.location.reload();
            }, 3000);
        });
    }

    return  <div sx={(theme)=>({
        [theme.breakpoints.down('md')]: {
            marginLeft: '-225px !important',
        },
    })}>
        <div className='infoPage'>
            <h2 className="pageTitle" id="tabelLabel" >Manage Partners</h2>
            <div className="col-sm-12 col-md-12 col-lg-12">
                <CommonTable
                    data={partners}
                    columns={columns}
                    itemsPerPage={10}
                    defaultSortField="name"
                    defaultSortDirection="asc"
                />
            </div>
            {loading ? <Loader/> : null}
            <Snackbar open={showMessage} message={message} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={6000} />
        </div>
        <ConfirmPasswordModal
            show={showPasswordConfirmation}
            onCancelClick={() => setShowPasswordConfirmation(false)}
            onYes={deletePartner}
            onLogOff={onLogOff} />
    </div>
}
ManagePartners.propTypes = {
    loggedInCustomerOrganization: PropTypes.string.isRequired,
    onLogOff: PropTypes.func.isRequired,
};
export default ManagePartners;